enum mapTypes {
  Set_Map_State = 'Set_Map_State',
  Reset_Map_State = 'Reset_State',
  Set_Log_Map_State = 'Set_Log_Map_State',
}
export default mapTypes;
